
// TODO:
// change speed based on length of text

function splitWords(el) {
	let wordCount = 0
	let letterCount = 0
	const words = el.innerText.replace('\n', ' <br> ').split(' ').filter(Boolean)

	el.innerHTML = words.map(word => {
		if (word === '<br>') return word

		const letters = word.trim().split('').map((letter, i) => 
			`<span 
				class="split-text__letter" 
				style="--letter:${i}; --letter-total:${letterCount++};"
			>${letter}</span>`
		)

		return `<span 
			class="split-text__word" 
			style="--word:${wordCount++}"
		>${letters.join('')}</span>`

	}).join(' ')
}

export default function init() {
	[...document.querySelectorAll('.split-text')].map(splitWords)
}